import type { JiraPlanDataRestResponse } from '@atlassian/jira-software-backlog-uif-types/src/index.tsx';

export interface Column {
	id: number;
	name: string;
	statusIds: string[];
	min?: number;
	max?: number;
}

export interface KanbanPlanDataRestResponse extends JiraPlanDataRestResponse {
	backlogColumn: Column;
	selectedForDevelopmentColumn: Column;
}

export type PlanDataResponse = JiraPlanDataRestResponse | KanbanPlanDataRestResponse;

export function isKanbanPlanDataResponse(
	response: unknown,
): response is KanbanPlanDataRestResponse {
	if (response !== null && typeof response === 'object') {
		return 'backlogColumn' in response && 'selectedForDevelopmentColumn' in response;
	}
	return false;
}

export interface FetchPlanOptions {
	rapidViewId: string | number;
	activeQuickFilters?: string[];
	forceConsistency?: boolean;
	normalizeEpics?: boolean;
	normalizeStatuses?: boolean[];
	operation?: string;
}
